<template>
    <sub-menu id="mobile-apps">
        <sub-menu-item to="/mobile-apps/universal-applications|/applications-mobiles/app-universelles" icon="fa-mobile-alt">
            <span v-tr>Universal Mobile Apps|Apps mobile universelles</span>
        </sub-menu-item>
        <sub-menu-item to="/mobile-apps/contact-tracing" icon="fa-chart-network">
            <span v-tr>Contact Tracing|Suivi des contacts</span>
        </sub-menu-item>
    </sub-menu>
</template>

<script>

import SubMenuItem from "@/components/sub-menu-item.vue";
import SubMenu from "@/components/sub-menu.vue";
export default {
    name: `mobile-apps-navigation`,
    components: {SubMenuItem, SubMenu}
}
</script>

<style lang="scss" scoped>
</style>
